module.exports = __webpack_public_path__ + "static/fuel-70c88b9e42ffab6c1a1c2fe1f7677f49.png";